import { Route } from '@angular/router';
import { authenticationGuard, userHasAnyRole } from '@wheere-front/shared-auth';
import { CUSTOMER_ROLES } from '@wheere-front/customer-shared-data-access';

// Customer-side user management routes (libs/customer-users) were intentionally
// removed 2026-05-29 — user provisioning happens in wheere-integrator now. The
// customer app is read-only for end users: site map, position history, export.
// The library is kept in the repo until backend invite parity lands on the
// integrator side, after which it can be deleted entirely.
export const routes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'sites',
  },
  {
    path: 'sites',
    loadChildren: () => import('@wheere-front/customer-map').then(m => m.MAPS_ROUTES),
    canActivate: [authenticationGuard(), userHasAnyRole(CUSTOMER_ROLES)],
  },
  {
    path: 'forbidden',
    loadComponent: () => import('@wheere-front/shared-feature').then(m => m.ForbiddenComponent),
  },
  {
    path: '**',
    loadComponent: () => import('@wheere-front/shared-feature').then(m => m.NotFoundComponent),
  },
];
